/*
 * @Author: lsqbeyond lsqbeyond@yeah.net
 * @Date: 2025-10-06 13:34:28
 * @LastEditors: lsqbeyond lsqbeyond@yeah.net
 * @LastEditTime: 2025-10-06 13:34:58
 * @FilePath: \tracenew\src\i18n\README.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * 多语言翻译配置说明
 * 
 * 翻译文件位置:
 * - 中文: src/i18n/locales/zh.js
 * - 英文: src/i18n/locales/en.js  
 * - 德语: src/i18n/locales/de.js
 * 
 * 当前已配置的翻译项:
 * 
 * 导航菜单 (nav):
 * - nav.overview: 之于行概览 / Company Overview / Firmenübersicht
 * - nav.companyIntro: 公司简介 / Company Introduction / Firmenvorstellung
 * - nav.team: 团队 / Team / Team
 * - nav.services: 服务范围 / Service Scope / Dienstleistungsbereich
 * - nav.expertise: 专业领域 / Expertise Areas / Fachbereiche
 * - nav.news: 动态资讯 / News & Updates / Nachrichten & Updates
 * - nav.contact: 联系我们 / Contact Us / Kontakt
 * 
 * 团队 (team):
 * - team.core: 核心团队 / Core Team / Kernteam
 * - team.patent: 专利团队 / Patent Team / Patent-Team
 * - team.trademark: 商标团队 / Trademark Team / Marken-Team
 * - team.foreign: 涉外团队 / Foreign Affairs Team / Auslandsangelegenheiten-Team
 * - team.translation: 翻译团队 / Translation Team / Übersetzungs-Team
 * - team.process: 流程团队 / Process Team / Prozess-Team
 * 
 * 服务 (services):
 * - services.patent: 专利服务 / Patent Services / Patent-Dienstleistungen
 * - services.trademark: 商标及著作权 / Trademark & Copyright / Marken & Urheberrecht
 * - services.trade: 商业秘密 / Trade Secrets / Geschäftsgeheimnisse
 * - services.rights: 侵权维权 / Rights Protection / Rechteschutz
 * 
 * 新闻 (news):
 * - news.important: 智见要闻 / Important News / Wichtige Nachrichten
 * - news.industry: 行业活动 / Industry Activities / Branchenaktivitäten
 * - news.social: 回馈社会 / Social Contribution / Sozialer Beitrag
 * - news.cooperation: 校企合作 / University Cooperation / Hochschulkooperation
 * 
 * 语言选择 (lang):
 * - lang.chinese: 中文 / 中文 / 中文
 * - lang.english: English / English / English
 * - lang.german: Deutsch / Deutsch / Deutsch
 * 
 * 如何添加新的翻译:
 * 1. 在对应的语言文件中添加新的键值对
 * 2. 在组件中使用 $t('key') 调用翻译
 * 3. 更新此文件记录新增的翻译项
 * 
 * 注意事项:
 * - 如果某个翻译项没有对应语言的翻译，会自动使用中文（fallback语言）
 * - 请不要删除已有的翻译键，以免影响页面显示
 * - 建议保持翻译键的层级结构清晰
 */

// 此文件仅用于说明，不会被打包
export default {}